import LayerWhere from '@/components/layers/LayerWhere';
import AggregateOperation from './AggregateOperation';
import ColumnName from './ColumnName';

class AggregateFunction {
  constructor(
    readonly _aggregateOp: AggregateOperation,
    readonly _columnName: Nullable<ColumnName>,
  ) {}

  clauses: Maybe<LayerWhere> = null;

  metricColumnName: Maybe<string> = null;

  static build(serverSideObj: AggregateFunction) {
    const aggOp = new AggregateOperation(serverSideObj._aggregateOp._name);
    const columnName = serverSideObj._columnName
      ? ColumnName.build(serverSideObj._columnName)
      : null;
    const aggregateFunction = new AggregateFunction(aggOp, columnName);
    if (serverSideObj.clauses) {
      aggregateFunction.clauses = LayerWhere.buildFromServer(
        serverSideObj.clauses,
      );
    }
    aggregateFunction.metricColumnName = serverSideObj.metricColumnName;
    return aggregateFunction;
  }

  aggregateOp() {
    return this._aggregateOp;
  }

  columnName() {
    return this._columnName;
  }

  toString(pks: ColumnName[] = [], aliases: Record<string, any> = {}) {
    const columnName = this.columnName();
    if (!columnName) {
      return 'row count';
    }
    const isPk = pks.some((pk) => pk.equals(columnName));
    let targetName = columnName.name();
    if (isPk && aliases[columnName.alias()]) {
      targetName = aliases[columnName.alias()].name();
    }
    return `${this.aggregateOp().name()} ( ${targetName} ) `;
  }
}

export default AggregateFunction;
